import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
    ROUTE_PATH, 
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
    APPLICATION_MODE_NEW,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
} from "../../app/constants";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { Header, NavigationLinkButton, Paragraph } from "../../components/RegularComponents";
import { removeAgentApplication } from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { replaceUrlParams } from "../../app/utils";

export const MraAgeNotEnough = () => {
    const agentApplication = useSelector(currentAgentApplicationSelector);
    const licencingSubType = agentApplication ? agentApplication.licencingSubType : LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
    const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  
    const title = !isPrincipalBroker ? 
      "Mortgage brokers and associate mortgage brokers must be at least 19 years old" :
      "Choose a new principal broker";

    const dispatch = useDispatch()
    return (
        <>
            <div className="container">
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">
                        <Header 
                            id="age-not-enough-header"
                            header={title}
                        />
                    </div>
                </div>
                {isPrincipalBroker && (
                    <div className="row bottomMarginMedium">
                        <div className="col-lg-8">
                            <Paragraph 
                                id="age-not-enough-text"
                                text={[
                                    "The principal broker for your brokerage must be at least 19 years old.",
                                    "Choose a new principal broker for your company."
                                ]}
                            />
                        </div>
                    </div>
                )}

                <div className="row bottomMarginNormal">
                <div className="col-lg-8">
                     <NavigationLinkButton 
                        onClick={() => {
                            // reset current agent application
                            if(!isPrincipalBroker && agentApplication?.id) { 
                                // set the current application change type as "DELETE"
                                dispatch(removeAgentApplication(agentApplication.id));

                                dispatch(saveBusinessLicenceApplicationData(
                                        APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE, APPLICATION_MODE_NEW))
                                    .then(data => {
                                        const nextPath = replaceUrlParams(ROUTE_PATH.WELCOME,
                                                    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, 
                                                    APPLICATION_MODE_NEW)
                                        dispatch(push(`${nextPath}`))
                                    })
                            } else { 
                                window.location.assign(ROUTE_PATH.LAUNCHPAGE_MORTGAGE)
                            }
                        }}
                        text={!isPrincipalBroker ? "Back to home page" : "Back to start"}
                    />
                </div>
            </div>
            </div>
        </>
    )
}